import React from 'react';
import ReserveFieldTime from '@/components/reserve/ReserveFieldTime/ReserveFieldTime';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormStartTime: React.FC = () => {
  const { form, weekDates, defaultValues, office, setStartTime } =
    useReserveForm();
  return (
    <ReserveFieldTime
      form={form}
      defaultValue={defaultValues.time}
      office={office || null}
      errors={form.formState.errors}
      setStartTime={setStartTime}
      weekDates={weekDates}
    />
  );
};
